export const errorTypes = {
  /* ======================
   * Client error types
   * ======================*/
  // Axios request cancelled
  REQUEST_CANCELLED_ERROR: 'REQUEST_CANCELLED_ERROR',
  // Connection blocked (no response), 503 - Bad gateway
  REQUEST_CONNECTION_ERROR: 'REQUEST_CONNECTION_ERROR',
  // Unexpected runtime error on the browser
  UNEXPECTED_RUNTIME_ERROR: 'UNEXPECTED_RUNTIME_ERROR',
  // Unhandled status codes returned by the server & response without error type
  UNEXPECTED_SERVER_ERROR: 'UNEXPECTED_SERVER_ERROR',
  // Rate limited blocked request
  REQUEST_BLOCKED_ERROR: 'REQUEST_BLOCKED_ERROR',
  /* ======================
   * Server error types
   * ======================*/

  // 400 Bad Request error, validation error
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  // 401 Unauthorized error, expired session
  UNAUTHORIZED_ERROR: 'UNAUTHORIZED_ERROR',
  // 404 Not Found
  NOT_FOUND_ERROR: 'NOT_FOUND_ERROR',
  // 403 Forbidden, CSRF token mismatch
  FORBIDDEN_ERROR: 'FORBIDDEN_ERROR',
  // 422 Request is valid, but unable to process request, business logic error
  UNPROCESSABLE_ENTITY_ERROR: 'UNPROCESSABLE_ENTITY_ERROR',
  // 500 Internal server error
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',

  STEPUP_AUTH_FAILURE_ERRORS: {
    VERIFICATION_FAILED: 'verification_failed',
    SERVICE_ERROR: 'service_error',
  },
}
